module.exports = __webpack_public_path__ + "assets/download.0d8cc238.svg";